import { useRef, useEffect } from 'react';

export function fixOverlayScroll(ref: HTMLElement | null) {
  const _overlay = ref;

  if (!_overlay) {
    return;
  }

  let _clientY = 0; // remember Y position on touch start

  _overlay.addEventListener(
    'touchstart',
    handleTouchstart,
    false,
  );

  _overlay.addEventListener(
    'touchmove',
    handleTouchmove,
    false,
  );

  function handleTouchstart(event: TouchEvent) {
    _overlay?.classList.add('scrolling');
    if (event.targetTouches.length === 1) {
      // detect single touch

      _clientY = event.targetTouches[0].clientY;
    }
  }

  function handleTouchmove(event: TouchEvent) {
    if (event.targetTouches.length === 1) {
      // detect single touch

      disableRubberBand(event);
    }
  }

  function disableRubberBand(event: TouchEvent) {
    const clientY = event.targetTouches[0].clientY - _clientY;

    if (Number(_overlay?.scrollTop) === 0 && clientY > 0) {
      // element is at the top of its scroll

      event.preventDefault();
    }

    if (isOverlayTotallyScrolled() && clientY < 0) {
      // element is at the top of its scroll

      event.preventDefault();
    }
  }

  function isOverlayTotallyScrolled() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
    if (!_overlay) {
      return 0;
    }

    return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
  }

  return function disableFlag() {
    _overlay?.removeEventListener('touchstart', handleTouchstart, false);
    _overlay?.removeEventListener('touchmove', handleTouchmove, false);
  };

}

export function useFixOverlayScroll() {
  const ref = useRef(null);
  useEffect(() => {
    const cancel = fixOverlayScroll(ref.current);
    return () => {
      cancel?.();
    };
  }, []);
  return ref;
}
